import template from './confirmUnlinkGmailSync.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
};
